





























































import { LessonDTO } from '../../../../src_server/entity/dto/LessonDTO';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CommonDialog from '../../../components/organisms/CommonDialog.vue';
import { dayjs, DTW_FORMAT_JA, DT_FORMAT_JA, T_FORMAT_JA, DTW_FORMAT_JA_WO_YM } from '../../../../src_server/common/momentExtends';
import { DaLessonsService } from '../../../biz/remote/DaLessonsService';
import { ScheduledLessonsDTO } from '../../../../src_server/entity/dto/ScheduledLessonsDTO';
import { LessonStates } from '../../../../src_server/entity/master/LessonStates';
import { MessageDialog } from '../../../utils/MessageDialog';
import { Session } from '../../../utils/Session';
import { ShiftTableService } from '../../../biz/remote/ShiftTableService';
import { LessonServiceFront } from '../../../biz/LessonServiceFront';
import { reportSend } from '../../../biz/reportSendLogic';
import DaReservationAddSection from './DaReservationAddSection.vue';
@Component({
  components: { CommonDialog, DaReservationAddSection },
  filters: {
    dateFormat(value: string): string {
      return dayjs(value).format(DTW_FORMAT_JA);
    },
    timeFormat(value: string): string {
      return dayjs(value).format(T_FORMAT_JA);
    },
    stateFormat(state: string) {
      return LessonStates.getDaState(state);
    },
  },
})
export default class DaLessonResevationCommitDialog extends Vue {
  private shift_table_id = 0;
  private dto: ScheduledLessonsDTO = new ScheduledLessonsDTO();
  private get title() {
    return `${this.dto.teacher.nickname}`;
  }

  private isCommit(state: string) {
    return LessonStates.COMMIT === state;
  }

  private isAlready(state: string) {
    return LessonStates.ALREADY === state;
  }

  private isReserevation(state: string) {
    return LessonStates.RESERVATION === state;
  }
  private canCancel(state: string) {
    return LessonStates.RESERVATION === state || LessonStates.COMMIT === state;
  }
  private getClassByState(state: string) {
    return LessonStates.getBadgeClassByState(state, false);
  }

  private datelimitFormat(dt: Date, limit: number) {
    return dayjs(dt)
      .add(-1 * limit, 'day')
      .endOf('day')
      .format(DTW_FORMAT_JA_WO_YM);
  }

  async reservation(student_user_id: string, student_nickname: string) {
    const isOK = await MessageDialog.confirm(`${student_nickname}さんの予約を登録します。よろしいですか？`);
    if (isOK) {
      const biz = new DaLessonsService();
      if (!this.dto.shift_table.user_id) {
        await MessageDialog.systemError('先生ID', '手動予約時');
        return;
      }
      if (!this.dto.shift_table.start_time) {
        await MessageDialog.systemError('開始時間', '手動予約時');
        return;
      }
      if (!this.dto.shift_table.end_time) {
        await MessageDialog.systemError('終了時間', '手動予約時');
        return;
      }
      if (!this.dto.shift_table.shift_table_id) {
        await MessageDialog.systemError('シフトID', '手動予約時');
        return;
      }

      const response = await biz.reservation(student_user_id, this.dto.shift_table.user_id, this.dto.shift_table.start_time, this.dto.shift_table.end_time, this.dto.shift_table.shift_table_id, false);
      if (response.hasError) {
        await MessageDialog.alert(response.errorDescription);
      } else {
        await MessageDialog.alert(`${response.data.reservationMessage}`);
        // データをリロード
        this.loadData(this.shift_table_id);
      }
    }
  }

  /**
   * 承認待ちをコミット
   */
  async commit(row: LessonDTO) {
    // MessageDialog.
    const isOK = await MessageDialog.confirm(`${row.student?.full_name}さんの${dayjs(row.lessons?.start_dt).format(DT_FORMAT_JA)}開始の予約を確定します。よろしいですか？`);

    if (isOK) {
      const biz = new DaLessonsService();
      row.commit = true;
      const response = await biz.reservationCommit(row.lessons, Session.getSessionBuildingId());
      if (response.hasError) {
        MessageDialog.alert(response.errorDescription);
        return;
      }
      await MessageDialog.alert(`${dayjs(row.lessons.start_dt).format(DT_FORMAT_JA)}の予約を確定しました`);
      // データをリロード
      this.loadData(this.shift_table_id);
    }
  }

  /**
   * 承認待ちや承認済みをキャンセル
   */
  async cancelLesson(row: LessonDTO) {
    const biz = new LessonServiceFront();
    row.commit = true;
    await biz.cancel(row.lessons.class_id!, async (class_id) => {
      await MessageDialog.alert(`${row.student?.full_name}さんの${dayjs(row.lessons.start_dt).format(DT_FORMAT_JA)}の予約をキャンセルしました`);
      // データをリロード
      this.loadData(row.lessons.class_id!);
      this.$emit('changed');
    });
  }

  /**
   * データのリロード
   */
  async loadData(shift_table_id: number) {
    const biz = new DaLessonsService();
    const response = await biz.getLessonByShiftTableId(shift_table_id);
    this.dto = response.data;
  }

  /**
   * ダイアログを開く
   */
  public async show(shift_table_id: number) {
    this.shift_table_id = shift_table_id;
    await this.loadData(shift_table_id);
    (this.$refs['reservation_commit_dialog'] as CommonDialog).show();
  }

  async saveMemo() {
    this.dto.shift_table.lesson_memo;
    const biz = new ShiftTableService();
    await biz.updateSchedule(this.dto.shift_table);
    await MessageDialog.info(`メモを保存しました。`);
  }

  async report(class_id: string) {
    reportSend(this, class_id, 'report');
    // routeHelper(this, 'DaAdminDailyReportPage', { class_id: `${class_id}` });
  }
  async reportDoc(class_id: string) {
    reportSend(this, class_id, 'doc');
    // routeHelper(this, 'DaAdminDailyReportDocPage', { class_id: `${class_id}` });
  }

  public close() {
    (this.$refs['reservation_commit_dialog'] as CommonDialog).hide();
  }

  async added(shift_table: number) {
    await this.loadData(this.shift_table_id);
  }
}
